import { useState } from 'react';
import { useAuth } from '../lib/auth.jsx';
import { supabase, rpc } from '../lib/supabase.js';

export default function Login() {
  const { signIn, session, boot, reloadBoot, signOut } = useAuth();
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [ownerName, setOwnerName] = useState('');

  // ล็อกอินแล้วแต่ยังไม่มีแถวใน rent.staff
  const needClaim = session && boot && !boot.me;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    const { error } = await signIn(email.trim(), pw);
    if (error) setErr(error.message === 'Invalid login credentials'
      ? 'อีเมลหรือรหัสผ่านไม่ถูกต้อง' : error.message);
    setBusy(false);
  };

  const claim = async () => {
    setBusy(true); setErr('');
    try {
      await rpc('rp_bootstrap_owner', { p_name: ownerName || 'เจ้าของ' });
      await reloadBoot();
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const forgot = async () => {
    if (!email.trim()) { setErr('กรอกอีเมลก่อน แล้วกด "ลืมรหัสผ่าน" อีกครั้ง'); return; }
    setBusy(true); setErr('');
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: location.origin + '/?v=setpw',
    });
    setErr(error ? error.message : 'ส่งลิงก์ตั้งรหัสผ่านไปที่อีเมลแล้ว — ลิงก์มีอายุจำกัด เปิดจากอีเมลล่าสุดเท่านั้น');
    setBusy(false);
  };

  return (
    <div className="loginwrap">
      <div className="loginbox">
        <div className="lg"><img src="/logo-ink.svg" alt="" /><h1>Rent<em style={{ fontStyle: 'normal' }}>Point</em></h1></div>
        <div className="sub">Camp Studio · ระบบเช่าและรับเทิร์นอุปกรณ์</div>

        {needClaim ? (
          boot.staff_empty ? (
            <>
              <div style={{ fontSize: 13.5, lineHeight: 1.6, marginBottom: 4 }}>
                ยังไม่มีพนักงานในระบบ — บัญชีที่ล็อกอินอยู่จะถูกตั้งเป็น <b>เจ้าของ</b> (ได้ทุกสิทธิ์)
              </div>
              <label>ชื่อที่ใช้แสดงในระบบ</label>
              <input value={ownerName} onChange={e => setOwnerName(e.target.value)} placeholder="เช่น ปุ้ย" />
              <button className="btn" disabled={busy} onClick={claim}>เริ่มใช้งานเป็นเจ้าของ</button>
              <button className="linkbtn" style={{ marginTop: 14 }} onClick={signOut}>ออกจากระบบ</button>
            </>
          ) : (
            <>
              <div style={{ fontSize: 13.5, lineHeight: 1.6 }}>
                บัญชีนี้ยังไม่ถูกเพิ่มเป็นพนักงาน RentPoint — ให้เจ้าของเพิ่มจากหน้า ตั้งค่า › พนักงาน
              </div>
              <button className="btn" style={{ marginTop: 20 }} onClick={signOut}>ออกจากระบบ</button>
            </>
          )
        ) : (
          <form onSubmit={submit}>
            <label>อีเมลพนักงาน</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} autoFocus autoComplete="username" />
            <label>รหัสผ่าน</label>
            <input type="password" value={pw} onChange={e => setPw(e.target.value)} autoComplete="current-password" />
            <button className="btn" disabled={busy}>เข้าสู่ระบบ</button>
            <button type="button" className="linkbtn" style={{ marginTop: 14 }} onClick={forgot}>ลืมรหัสผ่าน / ตั้งรหัสครั้งแรก →</button>
          </form>
        )}

        {err && <div className="err">{err}</div>}
      </div>
    </div>
  );
}
